import { render, staticRenderFns } from "./global-site-settings-popup.vue?vue&type=template&id=7d56ac4f&scoped=true&"
import script from "./global-site-settings-popup.vue?vue&type=script&lang=js&"
export * from "./global-site-settings-popup.vue?vue&type=script&lang=js&"
import style0 from "./global-site-settings-popup.vue?vue&type=style&index=0&id=7d56ac4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d56ac4f",
  null
  
)

component.options.__file = "global-site-settings-popup.vue"
export default component.exports